import { ComponentUtil } from '../../utils/ComponentUtil';
import { Hooks } from '../../types/Hooks';

ComponentUtil.loader(
  !!document.querySelector(Hooks.ModalRoot),
  () => import('./WorldMap'),
  (WorldMap) => {
    ComponentUtil.binder(Hooks.WorldMap, WorldMap);
  },
);
